import { ApiResult } from '@models/api';
import { useMutation, UseMutationOptions } from '@hooks/react-query';
import { fetcherMutation } from 'utils/react-query';

import { VerifyPinParam } from '../models/mutations';

function useRVerifyPin(
  options: UseMutationOptions<
    ApiResult<unknown>,
    Record<string, unknown>,
    VerifyPinParam
  > = {},
) {
  return useMutation<
    ApiResult<unknown>,
    Record<string, unknown>,
    VerifyPinParam
  >({
    mutationFn: async ({ context, variables }) =>
      await fetcherMutation({
        context: {
          ...context,
          method: 'POST',
          path: 'verify-pin',
        },
        variables,
      }),
    ...options,
  });
}

export default useRVerifyPin;
